import React, { createContext, useContext } from 'react';

export interface FeatureFlags {
  USE_STRIPE_PRORATION: boolean;
  ENABLE_TRIALS: boolean;
}

// Globale Konstante wird per Webpack inlined → Fallback für Tests/Storybook
// @ts-ignore
const globalFlags: FeatureFlags = typeof __PUBLIC_FLAGS__ !== 'undefined'
  ? __PUBLIC_FLAGS__
  : { USE_STRIPE_PRORATION: false, ENABLE_TRIALS: false };

const FeatureFlagContext = createContext<FeatureFlags>(globalFlags);

export const FeatureFlagProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <FeatureFlagContext.Provider value={globalFlags}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlags = () => useContext(FeatureFlagContext); 